import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { ApiService } from './api/api.service';


@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.css']
})
export class PurchaseComponent implements OnInit {

  constructor(public ApiService: ApiService,private titleService: Title) { }

  msearch : string;
  customer:any;
  products:any;
  summary : any = {customer:{},product:{}};

  productselected:number = null;
  productcode:string;
  anyproductselected:any = [];
  customerselected:number = null;
  customercode:string;
  successConfirm = false;


  error = false;
  result = false;
  formOpen = false;
  errMsg : string;

  loadingbuy = false;
  loadingbill = false;
  buttonbuydisable = true;
  radioService : number;
  CheckService : any = [];
  radioCustomer : number;

  ngOnInit() {
    this.titleService.setTitle('Purchase Service');
  }

  search()
  {
    alert(this.msearch);
    this.searchCustomer();
    //this.searchQueryParams = this.queryParams+'&search='+params;

    /*this.loadSearch({search:this.msearch});
    this.customerselected = null;
    this.productselected = null;
    this.summary = {customer:{},product:{}};
    this.radioCustomer = null;
    this.radioService = null;
    */
    
  }

  searchCustomer()
  {
    this.ApiService.searchCustomer({customerid: this.msearch }).subscribe((output:any) => {
        console.log(output);
        console.log(output.status);
        if ( output.status ){
          this.customer = output.data;
          this.error = false;
          this.formOpen = true;
          this.loadProd();
        }else{
         this.error = true;
         this.formOpen = false;
         this.errMsg = output.message;
        }
       
      });
  }

  loadProd()
  {
    console.log(this.customer);
    console.log(this.customer[0].mainservice.serviceid);

    this.ApiService.getAlacarte({serviceid:this.customer[0].mainservice.serviceid}).subscribe((output:any) => {
      if ( output.status ){
        this.products = output.data;
        //this.error = false;
        //this.result = true;
      }else{
       //this.error = true;
       //this.result = false;
       //this.errMsg = output.message;
      }
       
    });
  }

  pickproduct(i)
  {
    this.productselected = i;
    console.log(i);
    console.log(this.products[i]);

    if ( this.isChecked(i) ){
      this.CheckService.splice(i, 1);
      this.anyproductselected.splice(i, 1);
      this.summary.product = this.CheckService;
    }else{

      // this.radioService = this.products[i]['id'];
      this.CheckService[i] = this.products[i];
      this.summary.product = this.CheckService;
      this.anyproductselected[i] = this.products[i]['id'];
      if ( this.customerselected != null && this.productselected != null ){
        this.buttonbuydisable = false;
      }
    }

    console.log(this.CheckService);
    console.log(this.summary.product);

  }

  ada(items)
  {
    if (items == undefined){
      return false;
    } else{
      return true;
    }
  }

  selected(i)
  {
    if (i == this.productselected){
      return 'list-group-item-action list-group-item-primary';
    }else{
      return '';
    }
  }

  pickcustomer(i)
  {
    
    //console.log(i);
    //console.log(this.customer[i]);  
    if ( this.customer[i]['is_isp'] == 1 ){
      
      alert('Anda tidak dapat memilih ID Pelanggan ini');

    }else{
      this.customerselected = i;
      this.radioCustomer = this.customer[i]['customerid'];
      this.summary.customer = this.customer[i];
      if ( this.customerselected != null && this.productselected != null ){
        this.buttonbuydisable = false;
      }
    }
  }

  selectedcustomer(i)
  {
    if (i == this.customerselected){
      return 'list-group-item-action list-group-item-success';
    }else{
      return '';
    }
  }

 
  
  buydisabled()
  {
    return (!this.isCustomerSelected() || !this.isProductSelected());
    //return  this.buttonbuydisable;
  }




  calculate()
  {
      let ls = '';
      console.log(ls);
      for (let num of this.anyproductselected) {
        console.log(num);
        if ( ls == '' ){
          ls = ls + num;
        }
      }
      console.log(ls);

      let param = {
                "account_id": this.radioCustomer,
                "list_service":"174,181,80,1266,1265"
      };


      console.log(param);

      this.ApiService.Calculate(param).subscribe((output:any) => {
      console.log(output);
      if ( output.status ){
        this.products = output.data;
        //this.error = false;
        //this.result = true;
      }else{
       //this.error = true;
       //this.result = false;
       //this.errMsg = output.message;
      }
       
    });
  }
  
  buy()
  {
  
    this.loadingbuy = true;
    this.buttonbuydisable = true;
    // checkout
    let selected = this.products[this.productselected];
    let mycustomer = this.customer[this.customerselected];
    this.summary = {customer:mycustomer,product:selected};
    let data = {"ID":selected['productcode'],"CID":mycustomer['customerid']};
    console.log(data);
    console.log(this.summary);
/*
    setTimeout(() => {  
        this.successConfirm = true;
        this.formOpen = false; }, 
    2000);

    return;
*/

    /*return this.partnerService.PostWPCheckout(data).subscribe((output: any) => {
      console.log(output);
      if ( output.status ){
        //window.location.href = 'https://b2b-api.mncplay.id/billmain.php?CID='+mycustomer['customerid'];
        //this.successConfirm = true;
        //this.formOpen = false;

        let params = {customer_id:output.data['account_id'],paketname:output.data['paketname'],sn:output.data['sn'],price:output.data['price'], nohp:output.data['nohp']};

        this.WaNotif(params);

      }else{
       this.successConfirm = false; 
       alert(output.data.message);

       this.loadingbuy = false;
       this.buttonbuydisable = false;
       //this.error = true;
       //this.result = false;
       //this.errMsg = output.message;
      }
    })*/
  }

  onSubmit()
  {
    var data = new FormData();
  data.append("app_id", "ATV");
  data.append("localdatetime", "20200411204100");
  data.append("product_id", "50100");
  data.append("customer_id", "1000000665");
  data.append("signature", "4849d1ec62a4d0891bae574e4dd9ef0250d12752");

  var xhr = new XMLHttpRequest();
  xhr.withCredentials = true;

  xhr.addEventListener("readystatechange", function () {
    if (this.readyState === 4) {
      console.log(this.responseText);
    }
  });

  xhr.open("POST", "https://billing.mncplay.id/main/billinfo");
  xhr.setRequestHeader("Content-Type", "application/xhtml+xml");
  xhr.setRequestHeader("cache-control", "no-cache");
  xhr.setRequestHeader("Postman-Token", "16256e72-69a2-4e0e-b78c-d42969ed3283");

  xhr.send(data);
  }

  isCustomerSelected(){
    if ( this.customerselected == null ){
      return false;
    }else{
      return true;
    }
  }

  isProductSelected(){
    if ( this.productselected == null ){
      return false;
    }else{
      return true;
    }
  }

  isChecked(i){
    if ( this.CheckService[i] == undefined ){
      //this.CheckService[i] = 0;
      return false;
    } else if ( this.CheckService[i] ){
      return true;
    }else{
      return false;
    }
  }

  nextBill()
  {
    this.loadingbill = true;
    window.location.href = 'https://b2b-api.mncplay.id/billmain.php?CID='+this.summary.customer.customerid;
  }

  WaNotif(params)
  {
    /*return this.partnerService.PostWPWaNotif(params).subscribe((output: any) => {
      console.log(output);
      this.successConfirm = true;
        this.formOpen = false;
    },error=>{
      //alert('error');
      this.successConfirm = true;
        this.formOpen = false;
    });*/

  }
 
}


